import type {
  AlertAttributionQueryRequest,
  AlertAttributionReply,
  HTTPFailureEventPage,
  HTTPFailureEventPageRequest,
} from '../../types/alertAttribution';

type HTTPFailureQueryAPI = {
  queryHTTPFailures(
    request: AlertAttributionQueryRequest,
  ): Promise<AlertAttributionReply>;
  queryHTTPFailureEvents(
    request: HTTPFailureEventPageRequest,
  ): Promise<HTTPFailureEventPage>;
};

export async function queryHTTPFailureSummary(
  api: HTTPFailureQueryAPI,
  request: HTTPFailureEventPageRequest,
) {
  const summary = await api.queryHTTPFailures({
    ...request,
    detailLimit: 1,
    summaryOnly: true,
    includeEventCursor: true,
  });
  if (!summary.firstPageToken) {
    throw new Error('查询未返回事件游标，请确认服务端已升级后重试');
  }
  return summary;
}

export async function queryHTTPFailureWithFirstPage(
  api: HTTPFailureQueryAPI,
  request: HTTPFailureEventPageRequest,
  pageSize: number,
) {
  const summary = await queryHTTPFailureSummary(api, request);
  const firstPage = await api.queryHTTPFailureEvents({
    ...request,
    pageSize,
    pageToken: summary.firstPageToken,
  });
  return { summary, firstPage };
}
